import { render, staticRenderFns } from "./ListExpense.vue?vue&type=template&id=e97228ee"
import script from "./ListExpense.vue?vue&type=script&lang=js"
export * from "./ListExpense.vue?vue&type=script&lang=js"
import style0 from "./ListExpense.vue?vue&type=style&index=0&id=e97228ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports